export default __webpack_public_path__ + "static/media/group-7545.008cd8e5.svg";